import axios from "axios";
import { create } from "zustand";

interface Discount {
    id: number;
    name: string;
    percentage: string;
}

interface DiscountsStore {
    discounts: Discount[];
    fetchAndSetDiscounts: () => Promise<Discount[]>;
}

export const useDiscounts = create<DiscountsStore>((set, get) => ({
    discounts: [],
    fetchAndSetDiscounts: async () => {
        try {
            const res = await axios.get("wp-json/tts-booking/v1/events/discounts")

            let discounts = res.data;

            // Convert "0.1" to 10
            discounts.forEach((discount: Discount) => {
                discount.percentage = (Math.round(parseFloat(discount.percentage) * 100)).toString();
            });
            set({discounts: discounts});

            return Promise.resolve(discounts);
        } catch (err) {
            console.log(err);
        }
        return Promise.reject();
    },
}));

export type { Discount }